import ListingCard from './ListingCard.component';

export default ListingCard;